define(
    'plugins/musicfavourite/ui/button',['../util', '../events', './dom', './button-controller', './button-view', '../nls/text', 'exports'],
    function (util, PubSub, DOM, ButtonController, ButtonView, localisationString, /* exports */ Button) {

        'use strict';

        var _parseInput = function(input) {
            var domElem, options;

            if (typeof(input) == 'string') { // jQuery selector passed in
                domElem = DOM.findElement(input);

            } else if (typeof(input) == 'object') {
                if (input.nodeType == 1) { // DOM element
                    domElem = input;

                } else if (input[0] && input[0].nodeType && input[0].nodeType == 1) { // jQuery or similar input object passed in
                    domElem = input[0];

                } else {
                    options = input;
                }

            }

            if (domElem) {
                options = DOM.parseData(domElem);
                options.element = domElem;
            }

            options = options || {};

            // normalise lang
            options.lang = normaliseLocale(options.lang);

            options.item = util.parseItem(typeof(input.item) === 'string' ? input.item : options);

            if (options['aux']) {
                options.aux = util.parseItem(options['aux'], options.item.appid);
            }

            return options;
        },


        /**
         * Normalises locale string to supported values used in favourite buttons. Defaults to "en-gb".
         * @param  {string} locale Locale string to normalise.
         * @return {string}        Supported locale string for Favourites.
         */
        normaliseLocale = function(locale) {
            locale = typeof(locale) == 'string' && locale.toLowerCase() || 'en-gb';

            var supportedLocales = {
                'en': 'en-gb',
                'cy': 'cy-gb',
                'ga': 'ga-gb',
                'gd': 'gd-gb',
                'en-gb': 'en-gb',
                'cy-gb': 'cy-gb',
                'ga-gb': 'ga-gb',
                'gd-gb': 'gd-gb'
            };

            return supportedLocales[locale] || 'en-gb';
        },

        // Note: option names are camel-cased by _parseInput, so we need to validate against the camel-cased version.
        _validOptions = [ 'item', 'title', 'label', 'lang', 'variant', 'element', 'aux', 'parent', 'profile', 'ptrt', 'managementMode', 'feedbackMode', 'fillsContainer', 'cardSelector',  'useSigninOverlay', 'defaultAdded' ];

        /** Button */
        Button = function(input) {

            var options = _parseInput(input), key, i, self = this;

            for (i = 0; (key = _validOptions[i]); i++) {
                if (options[key] !== undefined) { //Using undefined for int values to pass the if statement
                    this[key] = options[key];
                }
            }

            this.id = this.item.toURN().replace(/[!'()*]/g, escape);
            this.title = (this.item.title || this.item.id).toString();
            this.variant = this.item.variant || 'standard';
            this.lang = this.item.lang;
            this.profile = this.profile || 'default';
            this.managementMode = this.item.managementMode == '1';
            this.feedbackMode = this.item.feedbackMode == '1';
            this.fillsContainer = this.item.fillsContainer == '1';
            this.cardSelector = this.item.cardSelector;
            this.useSigninOverlay = this.item.useSigninOverlay != '0';
            this.useModalSignin = this.item.useModalSignin == '1';
            this.defaultAdded = this.item.defaultAdded == '1';

            localisationString.text(this.profile, function(o) {
                self.text = o;
                self.controller = new ButtonController(self);
                self.view = new ButtonView(self);
            });
        };

        // PubSub Event contexts
        PubSub.context('button', Button);



        Button.createFromSelector = function(selector) {
            selector = selector || '.p-f';

            var out = [], obj, el, i, elems = DOM.findElement(selector);

            for (i = 0; (el = elems[i]); i++) {
                if (!el._bbcpfo) {
                    try {
                        obj = new Button(el);
                        out.push(obj);
                        el._bbcpfo = obj;

                    } catch(er) {
                        window.console && window.console.error(er, 'Could not create Favourite button');
                    }
                }
            }

            return out;
        };



        Button.refresh = function() {

        };

        return Button;
    }
);

